module.exports = __webpack_public_path__ + "static/image-placeholder-b42dbe7b2384f067613bd5d29be11089.png";